<template>
  <div class="verval">
    <v-card flat>
      <v-card-title>
        <h4 class="black--text">Daftar Kelompok Pendampingan PA</h4>
      </v-card-title>
      <v-divider />
      <v-card-title class="pa-0">
        <base-table-header
          :options="{ header: 'py-2' }"
          :btnAdd="$allow('psp-peserta-kp-pa.create') && gelombang === gelombangAktif[tahunKe]"
          :btnDownload="allowDownload"
          @add="onAdd"
          @reload="onReload"
          @search="onSearch"
          @download="onDownloadList"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah Data <span class="blue--text font-weight-medium">{{ total }}</span>
            </div>
          </template>
          <template v-slot:toolbar>
            <div style="max-width: 350px">
              <v-row no-gutters>
                <v-col cols="12" lg="6" class="py-2 pr-1">
                  <v-select
                    v-model="gelombang"
                    light
                    flat
                    dense
                    outlined
                    hide-details
                    :items="mGelombang"
                    @change="onChangeGelombang"
                  ></v-select>
                </v-col>
                <v-col cols="12" lg="6" class="py-2">
                  <v-select
                    v-model="tahunKe"
                    light
                    flat
                    dense
                    outlined
                    hide-details
                    :items="mTahun"
                    @change="onChangeTahun"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
          </template>
        </base-table-header>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row no-gutters>
                    <v-col cols="12" lg="4">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="blue">
                          <v-icon dark>mdi-hospital-building</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <v-list-item-title>
                            <v-label color="caption"><small>Nama Kelompok KP</small></v-label>
                          </v-list-item-title>
                          <div style="font-size: 16px" class="font-weight-medium mt-1">
                            {{ $getDeepObj(item, 'nama') || '-' }}
                          </div>
                          <div v-if="+item.is_khusus === 1" class="body-2 orange--text">
                            Kelompok Khusus
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" lg="8">
                      <v-row>
                        <v-col cols="12" lg="2">
                          <v-list-item class="px-0">
                            <v-list-item-content class="py-0">
                              <v-list-item-title>
                                <v-label color="caption"><small>Jumlah Anggota </small></v-label>
                              </v-list-item-title>
                              <v-list-item-subtitle class="link black--text body-1 mt-1">
                                <span class="blue--text"> {{ item.psp_kp_pa_sekolahs.data.length || 0 }} </span> Sekolah
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                        <v-col cols="12" lg="3">
                          <v-list-item class="px-0">
                            <v-list-item-content class="py-0">
                              <v-list-item-title>
                                <v-label color="caption"><small>Nama Fasilitator</small></v-label>
                              </v-list-item-title>
                              <v-list-item-subtitle class="link black--text body-2 mt-1">
                                <template v-if="getDataPendampingan(item)">
                                  {{
                                    $getDeepObj(getDataPendampingan(item), 'psp_profil_pa.data.ptk.data.nama') || '-'
                                  }}
                                </template>
                                <template v-else>-</template>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                        <v-col cols="12" lg="4">
                          <v-list-item class="px-0">
                            <v-list-item-content class="py-0">
                              <v-list-item-title>
                                <v-label color="caption"><small>Jadwal Berlangsung</small></v-label>
                              </v-list-item-title>
                              <v-list-item-subtitle class="link black--text body-2">
                                <div>
                                  <template v-if="dataMeta.pendampingan_ke">
                                    <v-chip small color="success">
                                      {{
                                        $getDeepObj(
                                          dataMeta,
                                          `config.pendampingan_ke-pmo.${gelombang}.${dataMeta.pendampingan_ke}`
                                        )
                                      }}
                                    </v-chip>
                                  </template>
                                  <template v-else>-</template>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                        <v-col cols="12" lg="3">
                          <v-list-item class="px-0">
                            <v-list-item-content class="py-0">
                              <v-list-item-title>
                                <v-label color="caption"><small>Aksi</small></v-label>
                              </v-list-item-title>
                              <v-list-item-subtitle class="link black--text body-2">
                                <v-btn depressed small dark color="blue" @click="onDetail(item)">Lihat Detail</v-btn>
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text>
                  <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full ref="modal" :title="formulir.title" @save="onSave">
      <component
        ref="formulir"
        :is="formulir.form"
        :initValue="formulir.init"
        :gelombang="formulir.gelombang"
        :tahun_ke="formulir.tahun_ke"
        jenis="kp_pa"
      />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import list from '@mixins/list';
import mixin from './mixin';
import actions from './action';
import FormKelompok from '../formulir/Kelompok';
import FormPindah from '../formulir/Pindah';
export default {
  components: { FormKelompok, FormPindah },
  mixins: [mixin, list],
  data() {
    return {
      actions: actions,
      formulir: {},
      config: {},
      gelombang: 2,
      tahunKe: 0,
    };
  },
  mounted() {
    const gelombangs = this.$getDeepObj(this.configPendampingan, 'kp-pa.gelombang') || [];
    const tahunKe = this.$getDeepObj(this.configPendampingan, 'kp-pa.tahun_ke') || {};
    const [gelombang] = [...[], ...gelombangs].slice(-1);

    this.gelombang = gelombang;
    this.tahunKe = tahunKe[gelombang] || '';

    this.params.gelombang = this.gelombang;
    this.params.tahun_ke = this.tahunKe;
  },
  methods: {
    ...mapActions('diklatPa', {
      fetch: 'fetch',
      create: 'create',
      update: 'update',
      delete: 'delete',
      pindah: 'pindah',
      getDetail: 'getDetail',
      downloadList: 'downloadList',
    }),
  },
};
</script>
